import * as React from 'react';
import classNames from 'classnames';
import styles from '../../styles/flyouts/tasks/Relations.scss';
import TaskPath from './relations/TaskPath';
import TaskDependencies from './relations/TaskDependencies';
import RelatedTasks from './relations/RelatedTasks';

const Relations = ({ data, collapsed }) => (
  <div className={classNames(styles.scroller, collapsed && styles.collapsed)}>
    <TaskPath data={data} />
    <TaskDependencies data={data} />
    <RelatedTasks data={data} />
  </div>
);

export default Relations;
